import Vue from 'vue'

import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'
import './bootstrap.scss'

Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)
